// ✅ App.js — Mortgage Matrix Routing
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Calculator from "./calculators/calculator"; // 👈 calculators already in components
import BrokerDashboard from "../pages/BrokerDashboard";
import ClientApplication from "../pages/ClientApplication";
import CalculatorList from "../helpers/calculatorList";
import BrokerCRM from "./BrokerCRM/BrokerCRM";

// ✅ New import for Refinance Form Flow
import RefinanceForm from "./RefinanceForm/RefinanceForm";

function App() {
  return (
    <Router>
      <Routes>
        {/* Default calculators page */}
        <Route
          path="/"
          element={<Calculator selectedCalc={CalculatorList.borrowingCapacity} />}
        />

        {/* Broker dashboard */}
        <Route path="/broker" element={<BrokerDashboard />} />

        {/* First home buyer application form */}
        <Route path="/welcome" element={<ClientApplication />} />

        {/* ✅ Refinance application form (new flow) */}
        <Route path="/refinance" element={<RefinanceForm />} />

        {/* Broker CRM route */}
        <Route path="/broker-crm" element={<BrokerCRM />} />
      </Routes>
    </Router>
  );
}

export default App;
